module.exports = __webpack_public_path__ + "img/phone.8875055b.svg";